import { render, staticRenderFns } from "./ProfileCredentialsChange.vue?vue&type=template&id=4eb05ae4&scoped=true"
import script from "./ProfileCredentialsChange.vue?vue&type=script&lang=js"
export * from "./ProfileCredentialsChange.vue?vue&type=script&lang=js"
import style0 from "./ProfileCredentialsChange.vue?vue&type=style&index=0&id=4eb05ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb05ae4",
  null
  
)

export default component.exports